import React from "react";
import { BrowserRouter, Routes as RouterRoutes, Route } from "react-router-dom";
import ScrollToTop from "components/ScrollToTop";
import ErrorBoundary from "components/ErrorBoundary";
import NotFound from "pages/NotFound";
import ResultsAndDownloadCenter from './pages/results-and-download-center';
import QuizParticipationInterface from './pages/quiz-participation-interface';
import ThankYouPage from './pages/thank-you';

const Routes = () => {
  return (
    <BrowserRouter>
      <ErrorBoundary>
      <ScrollToTop />
      <RouterRoutes>
        <Route path="/" element={<QuizParticipationInterface />} />
        <Route path="/results-and-download-center" element={<ResultsAndDownloadCenter />} />
        <Route path="/quiz-participation-interface" element={<QuizParticipationInterface />} />
        <Route path="/merci" element={<ThankYouPage />} />
        <Route path="*" element={<NotFound />} />
      </RouterRoutes>
      </ErrorBoundary>
    </BrowserRouter>
  );
};

export default Routes;
